import { render, staticRenderFns } from "./relatedOrders.vue?vue&type=template&id=51100e19&scoped=true&"
import script from "./relatedOrders.vue?vue&type=script&lang=js&"
export * from "./relatedOrders.vue?vue&type=script&lang=js&"
import style0 from "./relatedOrders.vue?vue&type=style&index=0&id=51100e19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51100e19",
  null
  
)

export default component.exports